import {ADD_APPOINTMENT, REMOVE_APPOINTMENT} from '../types.js'

export const addAppointment = data => dispatch => {
  let payload = {}

  let id_num = Math.floor(Math.random() + 10000);

  payload.id = id_num;
  payload.client_name = `${data.firstName} ${data.lastName}`;
  payload.date = `${data.date} ${data.time}`;
  payload.stylist_id = data.stylist;
  payload.service = data.services;

  dispatch({type: ADD_APPOINTMENT, payload: payload})
};

export const removeAppointment = appoint_id => (dispatch, getState) => {
  const prevAppointments = getState().appointment.appointments;
  let updatedAppointments = prevAppointments.filter(appointment => appointment.id.toString() !== appoint_id.toString());
  dispatch({type: REMOVE_APPOINTMENT, payload: updatedAppointments});
}